export type MarginProduct = {
  value: string;
  label: string;
  price: number;
  contractSize: number;
  quote: string;
  priceDecimals: number;
};

export const MARGIN_PRODUCTS: MarginProduct[] = [
  { value: 'EURUSD', label: 'EUR/USD', price: 1.0845, contractSize: 100000, quote: 'USD', priceDecimals: 4 },
  { value: 'GBPUSD', label: 'GBP/USD', price: 1.268, contractSize: 100000, quote: 'USD', priceDecimals: 4 },
  { value: 'USDJPY', label: 'USD/JPY', price: 153.2, contractSize: 100000, quote: 'JPY', priceDecimals: 2 },
  { value: 'AUDUSD', label: 'AUD/USD', price: 0.652, contractSize: 100000, quote: 'USD', priceDecimals: 4 },
  { value: 'USDCAD', label: 'USD/CAD', price: 1.368, contractSize: 100000, quote: 'CAD', priceDecimals: 4 },
  { value: 'XAUUSD', label: 'XAU/USD', price: 2392.4, contractSize: 100, quote: 'USD', priceDecimals: 1 },
];

export const MARGIN_CURRENCIES = [
  { value: 'USD', label: 'USD', rate: 1 },
  { value: 'EUR', label: 'EUR', rate: 0.92 },
  { value: 'GBP', label: 'GBP', rate: 0.79 },
  { value: 'JPY', label: 'JPY', rate: 151 },
  { value: 'VND', label: 'VND', rate: 25300 },
];

export const QUOTE_RATES: Record<string, number> = {
  USD: 1,
  JPY: 151,
  CAD: 1.368,
};

export const MARGIN_LEVERAGES = [
  { value: '50', label: '1:50' },
  { value: '100', label: '1:100' },
  { value: '200', label: '1:200' },
  { value: '500', label: '1:500' },
  { value: '1000', label: '1:1000' },
];

export const MARGIN_LOT_QUICK = [0.01, 0.1, 0.5, 1, 2];

export const LEVERAGE_VARIATIONS = [
  { leverage: 50, margin: 2169 },
  { leverage: 100, margin: 1084.5 },
  { leverage: 200, margin: 542.25 },
  { leverage: 500, margin: 216.9 },
  { leverage: 1000, margin: 108.45 },
];

export const MARGIN_MISTAKES = [
  {
    icon: 'ri-speed-up-line',
    title: 'Chọn đòn bẩy quá cao',
    desc: 'Đòn bẩy cao làm ký quỹ thấp, dễ khiến bạn mở vị thế quá lớn so với số dư tài khoản.',
  },
  {
    icon: 'ri-scales-3-line',
    title: 'Bỏ qua kích thước hợp đồng',
    desc: 'Vàng (100 oz/lot) khác hẳn ngoại hối (100.000 đơn vị/lot). Tính sai đơn vị sẽ sai toàn bộ ký quỹ.',
  },
  {
    icon: 'ri-exchange-line',
    title: 'Nhầm lẫn tiền tệ',
    desc: 'Ký quỹ được tính bằng tiền định giá, cần quy đổi về tiền tệ tài khoản để biết số tiền thực tế bị giữ.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Không tính giá hiện tại',
    desc: 'Giá thay đổi làm ký quỹ thay đổi theo. Cùng một lệnh, giá càng cao thì ký quỹ yêu cầu càng lớn.',
  },
];

export const MARGIN_WHY_FEATURES = [
  {
    icon: 'ri-shield-flash-line',
    title: 'Tránh bị ép đóng lệnh',
    desc: 'Biết trước số tiền bị giữ giúp bạn không rơi vào tình trạng ký quỹ không đủ và bị sàn đóng lệnh tự động.',
  },
  {
    icon: 'ri-funds-line',
    title: 'Phân bổ vốn hợp lý',
    desc: 'Tính tổng ký quỹ cho nhiều lệnh cùng lúc để chừa đủ biên an toàn, không dồn quá nhiều vào một vị thế.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Hiểu chi phí thực tế',
    desc: 'Ký quỹ không phải là phí, nhưng là số vốn bị "đóng băng". Nắm rõ nó để quản lý dòng tiền tài khoản.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'So sánh đòn bẩy tức thì',
    desc: 'Thấy ngay cùng một lệnh, đòn bẩy 1:100 và 1:500 chênh nhau bao nhiêu ký quỹ để chọn mức phù hợp.',
  },
];

export const MARGIN_WHY_SCENARIOS = [
  {
    icon: 'ri-arrow-go-forward-line',
    title: 'Trước mỗi lệnh mới',
    desc: 'Kiểm tra ký quỹ cần thiết trước khi bấm nút vào lệnh.',
  },
  {
    icon: 'ri-stack-line',
    title: 'Mở nhiều vị thế cùng lúc',
    desc: 'Cộng dồn ký quỹ để biết tổng số tiền đang bị giữ.',
  },
  {
    icon: 'ri-wallet-3-line',
    title: 'Số dư thay đổi',
    desc: 'Tính lại khi nạp thêm hoặc rút bớt tiền trong tài khoản.',
  },
  {
    icon: 'ri-swap-line',
    title: 'Đổi đòn bẩy hoặc sản phẩm',
    desc: 'So sánh nhanh khi chuyển đòn bẩy hay sang vàng, chỉ số.',
  },
];

export const MARGIN_RELATED_TOOLS = [
  {
    icon: 'ri-crosshair-line',
    title: 'Máy tính Khối lượng',
    desc: 'Tính số Lot dựa trên số dư, rủi ro và Stop Loss.',
    to: '/may-tinh-khoi-luong',
    accent: '#059669',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Máy tính Lợi nhuận & Thua lỗ',
    desc: 'Tính lợi nhuận hoặc thua lỗ dự kiến.',
    to: '/lai-lo',
    accent: '#10b981',
  },
  {
    icon: 'ri-percent-line',
    title: 'Máy tính Chi phí Spread',
    desc: 'Tính chi phí Spread của giao dịch.',
    to: '/doi-chieu',
    accent: '#f59e0b',
  },
  {
    icon: 'ri-shield-line',
    title: 'Máy tính Rủi ro',
    desc: 'Tính số tiền có thể chịu rủi ro dựa trên tài khoản.',
    to: '/rui-ro',
    accent: '#d97706',
  },
];